<template>
    <div class="cart-container">
        <icon name="cart" />
        <div class="cart-count">{{ count }}</div>
    </div>
</template>

<script>
import Icon from "@/Shared/Icon.vue";

export default {
    name: 'CartIcon',
    components: {Icon},
    props: {
        count: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style>
.cart-container {
    position: relative;
    display: inline-block;
}
.cart-count {
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 2px 5px;
    font-size: 12px;
}
</style>
